import { RootDispatch } from "redux/rootReducer";
import { load, loadFail, loadSuccess } from "./authenticationInfoActions";
import * as request from "utility/request";
import { AuthenticationInfo } from "types/AuthenticationInfo";

const apiUrl = process.env.REACT_APP_API_URL;

export const loadAuthenticationInfos = () => {
  return async (dispatch: RootDispatch) => {
    dispatch(load());

    try {
      const res = await request.getResponseJson<AuthenticationInfo[]>(
        `${apiUrl}/api/authenticationInfo`
      );
      dispatch(loadSuccess(res));
    } catch (error) {
      return request.handleFetchError(dispatch, error, loadFail(error));
    }
  };
};
